import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HeaderNotification } from '@core/domain/model/notifications/notification.model';
import { AppCookiesConsentState } from '@store/states/app.state';

export const appActions = createActionGroup({
  source: 'App',
  events: {
    hydrateApp: emptyProps(),
    showLoading: emptyProps(),
    hideLoading: emptyProps(),
    showCustomLoading: props<{ loading: string }>(),
    hideCustomLoading: props<{ loading: string }>(),
    visitedHeader: props<{ header: HeaderNotification }>(),
    enableScroll: emptyProps(),
    disableScroll: emptyProps(),
    setCookiesConsent: props<AppCookiesConsentState>(),
    emptyAction: emptyProps(),
  },
});
